<div [class.loader-hidden]="!showTag">
  <div id="loader" class="loading-indicator">
    <div>
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  </div>
</div>
